<template>
	<div>
		<j-card class="flex wrap p4 xs-12 bg5">
			<!-- Name -->
			<core-form-input
				name="name"
				v-model="template.name"
				v-validate="'required'"
				:validationErrors="errors"
				componentName="j-base-input-text"
				:label="$t('name')"
				@blur="updateTemplate"
			/>
			<!-- Description -->
			<core-form-input
				name="description"
				v-model="template.description"
				class="mt4"
				componentName="j-base-input-long-text"
				:label="$t('description')"
				@blur="updateTemplate"
			/>
			<!-- subject -->
			<core-form-input
				name="subject"
				v-model="template.subject"
				class="mt4"
				componentName="j-base-input-text"
				:label="$t('subject')"
				@blur="updateTemplate"
			/>
			<!-- Starter Template Selection -->
			<core-form-input
				v-if="currentType === 'create'"
				name="select_starter_template"
				v-model="startingTemplate.selected"
				:options="startingTemplate.options"
				class="mt4"
				componentName="j-base-select"
				:label="$t('select_starter_template')"
			/>

			<div class="flex xs-12 xs-right mt4" v-if="currentType === 'create'">
				<j-button @click="createTemplate">{{
					currentType === "create"
						? $t("create_template")
						: $t("update_template")
				}}</j-button>
			</div>
		</j-card>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import JCard from "@/components/JCard"
import api from "../../api/"

export default {
	props: {
		currentType: null,
		payload: {
			type: Object,
			default: () => {
				return null
			}
		}
	},

	components: {
		CoreFormInput,
		JButton,
		JCard
	},

	data() {
		return {
			template: {
				name: null,
				description: null,
				subject: null,
				mjml:
					"<mjml>\n    <mj-body>\n        <mj-section>\n            <mj-column>\n                <mj-text>Default starting template</mj-text>\n            </mj-column>\n        </mj-section>\n    </mj-body>\n</mjml>"
			},
			startingTemplate: {
				options: [{ name: "default", value: "default" }],
				selected: "default"
			}
		}
	},

	methods: {
		async createTemplate() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			const res = await api.createEmailMjmlTemplate({
				input: {
					name: this.template.name,
					mjml: this.template.mjml,
					subject: this.template.subject,
					description: this.template.description
				}
			})

			if (res.errors) this.$store.dispatch("showError", res.errors)
			else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("template_created")
					}
				})

			this.$router.push({
				name: "TemplatesList"
			})
		},

		async updateTemplate() {
			const isValid = await this.$validator.validate()
			if (!isValid) return
			console.log("EMAIL", this.template)
			const res = await api.updateEmailMjmlTemplate({
				templateId: this.$route.params.id,
				input: {
					name: this.template.name,
					mjml: this.template.mjml,
					subject: this.template.subject,
					description: this.template.description
				}
			})

			if (res.errors) this.$store.dispatch("showError", res.errors)
			else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("template_updated")
					}
				})
		}
	},

	mounted() {
		if (this.payload !== null) this.template = this.payload
	}
}
</script>
